import { putResolve } from 'redux-saga/effects'
import _requestRemoveUserFromGroup from 'store/sagas/requestRemoveUserFromGroup'

export default function * requestRemoveUserFromGroup (action) {
  const { userId, userGroupId } = action.payload

  yield putResolve(_requestRemoveUserFromGroup({
    userId,
    userGroupId
  }))
}

